export default (theme) => ({
  animatedCheck: {
    width: 290,
    maxHeight: 290,
    height: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: 185,
    },
    [theme.breakpoints.down('md')]: {
      width: 155,
    },
  },
  check: {
    stroke: theme.palette.primary.main,
    strokeDasharray: 1000,
    strokeDashoffset: -100,
    WebkitAnimation: '$check 2s .35s ease-in-out forwards',
    animation: '$check 2s .35s ease-in-out forwards',
  },
  circle: {
    stroke: theme.palette.primary.main,
    strokeDasharray: 1000,
    strokeDashoffset: 0,
    WebkitAnimation: '$circle 1.5s 0s ease-in-out forwards',
    animation: '$circle 1.5s 0s ease-in-out forwards',
  },
  '@keyframes check': {
    '0%': {
      strokeDashoffset: -100,
    },
    '100%': {
      strokeDashoffset: 900,
    },
  },
  '@keyframes circle': {
    '0%': {
      strokeDashoffset: 1000,
    },
    '100%': {
      strokeDashoffset: 0,
    },
  },
});
